angular.module('impactx.lot').controller('LotBuyerListCtrl',
    LotBuyerListCtrl);

LotBuyerListCtrl.$inject = ['$routeParams', 'selectedListItems', 'BackService', 'BackFactory'];

function LotBuyerListCtrl($routeParams, selectedListItems, BackService, BackFactory)
{
    var ctrl = this;

    this.getDetailLink = function() {
        if (selectedListItems.getFirstSelectedItem())
        {
            return "lotbuyerdetail/" + selectedListItems.getFirstSelectedItem().id + "/"  + selectedListItems.getFirstSelectedItem().lotId;
        }
        return "";
    };

    this.backFunction = function () {
        BackFactory.setLotId($routeParams.lotId);
        BackService.back();
    };

    var buttonDefinition = [
        {label: "details", linkFunction: ctrl.getDetailLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'ViewLotBuyer'}
    ];

    this.meta = {
        rowTemplate: 'modules/lot/templates/lotbuyerlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/lot/buyerlist',
        id: "lotbuyerlist",
        valuesInteger: [{name:"LOT_Id", value: $routeParams.lotId}],
        mainAction : {id:"new", link: "#/lotbuyerdetail/0/" + $routeParams.lotId + "/", icon:"mdi-plus"},
        backFunction: ctrl.backFunction,
        buttonDefinition: buttonDefinition
    };
    this.getMeta = function () {
        return this.meta;
    }
}